import RepositoryBase from "./repositoryBase";
import EshopRequestBuilder from "../data/eshopRequestBuilder";
import AuthorizationService from "../services/authorizationService";
import EventBus from "../services/eventBus";
import SystemComponentOutagesResponse from "entities/systemComponentOutagesResponse";
import { plainToInstance } from "class-transformer";

export default class OutageRepository extends RepositoryBase<EshopRequestBuilder> {
  constructor(
    protected apiFactory: ReturnType<typeof EshopRequestBuilder.Factory>,
    protected authorizationService: AuthorizationService,
    protected eventBus: EventBus
  ) {
    super(() => apiFactory(), authorizationService, eventBus);
  }

  getSystemComponentOutages() {
    return this.callApi(api =>
      api
        .apiVersion(3)
        .all("system_component_outages")
        .get<SystemComponentOutagesResponse>()
        .then(response => plainToInstance(SystemComponentOutagesResponse, response))
    );
  }
}
